{
  "dashboard.title": "忠诚度仪表盘",
  "actionReferralReportDownloadButton.tooltip": "推荐计划报告是一个包含推荐信息的 CSV 文件。下载可能需要几分钟。",
  "actionReferralReportDownloadButton.label": "下载推荐计划报告",
  "referralRevenueWidget.title": "净收入和投资回报",
  "referralRevenueWidget.roiTotals.title": "投资回报",
  "referralRevenueWidget.roiTotals.titleTooltip": "所选时间期间内的净收入除以投资。",
  "referralRevenueWidget.investmentTotals.title": "投资",
  "referralRevenueWidget.investmentTotals.titleTooltip": "所选时间期间内用于购买的推荐优惠券的总成本。",
  "referralRevenueWidget.revenueTotals.title": "净收入",
  "referralRevenueWidget.revenueTotals.titleTooltip": "在选定时间期间内，减去所有折扣后从推荐购买中获得的总收入。",
  "referralRevenueWidget.chartMetaData.displayName.revenue": "净收入",
  "referralRevenueWidget.chartMetaData.displayName.investment": "投资",
  "referralRevenueWidget.chartMetaData.displayName.roi": "投资回报",
  "referralSucccessWidget.chartMetaData.diaplayName.successRate": "成功率",
  "referralSucccessWidget.successRate.title": "成功率",
  "referralSucccessWidget.successRate.titleTooltip": "根据您的 Smart Insights 新近设置，在选定时间期间内被推荐朋友兑换的推荐代码百分比。",
  "referralSucccessWidget.title": "推荐成功率",
  "referralVouchersWidget.title": "推荐优惠券",
  "referralVouchersWidget.redeemedTotal.title": "兑换的优惠券",
  "referralVouchersWidget.redeemedTotal.titleTooltip": "被推荐朋友兑换的推荐代码总数。",
  "referralVouchersWidget.issuedTotal.title": "已发放优惠券",
  "referralVouchersWidget.issuedTotal.titleTooltip": "忠诚度会员发送给被推荐朋友的推荐代码总数。",
  "referralVouchersWidget.chartMetaData.issuedVouchers.displayName": "已发放优惠券",
  "referralVouchersWidget.chartMetaData.redeemedVouchers.displayName": "兑换的优惠券",
  "averageOrderValueWidget.title": "平均订单值",
  "averageOrderValueWidget.totals.nonLoyaltyMembers": "非忠诚度会员",
  "averageOrderValueWidget.totals.loyaltyMembers": "忠诚度会员",
  "averageOrderValueWidget.totals.uplift": "忠诚度提升",
  "averageOrderValueWidget.chart.nonLoyaltyMembers": "非忠诚度会员",
  "averageOrderValueWidget.chart.loyaltyMembers": "忠诚度会员",
  "dashboardEmptyState.title": " 没有要显示的数据。",
  "dashboardEmptyState.lead": "您没有任何数据可显示。",
  "dashboardView.loyaltyImpact.title": "忠诚度影响",
  "dashboardView.numOfMembersWidget.title": "忠诚度会员增长",
  "dashboardView.engagementRatesWidget.title": "忠诚度参与",
  "dashboardView.pointsAnalyticsWidget.title": "奖励分析",
  "engagementRatesWidget.title": "参与率",
  "engagementRatesWidget.totalsEngagement.ratePct.title": "忠诚度参与率",
  "engagementRatesWidget.totalsRedemption.ratePct.title": "积分参与率",
  "inThePastDays": "过去 {selectedDaysRange} 天内。",
  "engagementRatesWidget.mainSeries.redemtion.name": "积分兑换率",
  "engagementRatesWidget.redemptionRateWidget.title": "积分兑换率",
  "engagementRatesWidget.redemptionRateWidget.titleTooltip": "根据您的 Smart Insights 新近设置，在选定时间期间内兑换奖励的总积分百分比。",
  "engagementRatesWidget.engagementRateWidget.titleTooltip": "在选定时间期间内通过购买和操作积累计分或兑换积分以获得奖励的会员百分比。",
  "engagementRatesWidget.engagementRateWidget.title": "忠诚度参与率",
  "engagementRatesWidget.chartMetaData.main.displayName": "忠诚度参与率",
  "enrollmentsWidget.title": "忠诚度注册",
  "enrollmentsWidget.totals.leadTotal.title": "已注册潜在客户",
  "enrollmentsWidget.totals.customerTotal.title": "已注册会员",
  "enrollmentsWidget.totals.enrollTotal.title": "总注册人数",
  "enrollmentsWidget.tooltip.label": "忠诚度注册",
  "enrollmentsWidget.chartMetaData.customer.displayName": "会员",
  "enrollmentsWidget.chartMetaData.lead.displayName": "潜在客户",
  "generatedRevenueWidget.title": "忠诚度会员收入",
  "generatedRevenueWidget.widgetCollapsedContentElement.totalRevenue.title": "总收入",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyRevenue.title": "忠诚度收入",
  "generatedRevenueWidget.widgetCollapsedContentElement.loyaltyImpactPct.title": "忠诚度收入影响",
  "generatedRevenueWidget.chartDataTotalRevenue.name": "总收入",
  "generatedRevenueWidget.chartDataLoyaltyRevenue.name": "忠诚度收入",
  "generatedRevenueWidget.totals.loyaltyImpactPct.titleTooltip": "您的忠诚度计划产生的总收入的百分比。",
  "generatedRevenueWidget.totals.loyaltyImpactPct.title": "忠诚度收入影响",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.title": "忠诚度操作收入",
  "generatedRevenueWidget.totals.loyaltyActionRevenue.titleTooltip": "会员完成的忠诚度操作产生的收入。",
  "generatedRevenueWidget.totals.loyaltyRevenue.title": "忠诚度总收入",
  "generatedRevenueWidget.totals.loyaltyRevenue.titleTooltip": "选定时间期间内忠诚度会员产生的总收入。",
  "generatedRevenueWidget.totals.totalRevenue.title": "总收入",
  "generatedRevenueWidget.totals.totalRevenue.titleTooltip": "总收入包括根据选定时间期间内销售数据的所有购买。总收入还包括退回的商品（退款），这些商品会降低总收入的价值。",
  "generatedRevenueWidget.chartTooltipContent.totalRevenue.label": "总收入",
  "generatedRevenueWidget.chartTooltipContent.loyaltyRevenue.label": "忠诚度总收入",
  "generatedRevenueWidget.chartTooltipContent.totalActionRevenue.label": "忠诚度操作收入",
  "generatedRevenueWidget.chartTooltipContent.loyaltyImpactPct.label": "忠诚度收入影响",
  "numOfMembersWidget.title": "忠诚度会员总数",
  "numOfMembersWidget.total.title": "忠诚度会员",
  "numOfMembersWidget.chartTooltipContent.label": "忠诚度会员",
  "pointsAnalyticsWidget.title.spend": "业绩分析",
  "pointsAnalyticsWidget.title.points": "积分分析",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.displayName": "累计业绩",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulated.totalsTooltip": "选定时间期间内已确认的业绩总额。",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.displayName": "累计现金返还",
  "pointsAnalyticsWidget.chartMetadata.spend.accumulatedBashback.totalsTooltip": "选定时间期间内已确认的现金返还总额。",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.displayName": "待处理业绩",
  "pointsAnalyticsWidget.chartMetadata.spend.pending.totalsTooltip": "选定时间期间内待处理业绩总额。",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.displayName": "已过期业绩",
  "pointsAnalyticsWidget.chartMetadata.spend.expired.totalsTooltip": "选定时间期间内已过期业绩总量。",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.displayName": "累计积分",
  "pointsAnalyticsWidget.chartMetadata.points.accumulated.totalsTooltip": "选定时间期间内已确认业绩的总金额。",
  "pointsAnalyticsWidget.chartMetadata.points.pending.displayName": "待处理积分",
  "pointsAnalyticsWidget.chartMetadata.points.pending.totalsTooltip": "选定时间期间内待处理积分的总金额。",
  "pointsAnalyticsWidget.chartMetadata.points.expired.displayName": "已过期/已移除积分",
  "pointsAnalyticsWidget.chartMetadata.points.expired.totalsTooltip": "选定时间期间内已过期/已移除积分的总金额。",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.displayName": "已兑换积分",
  "pointsAnalyticsWidget.chartMetadata.points.redeemed.totalsTooltip": "选定时间期间内已兑换积分的总金额。",
  "purchaseFrequencyWidget.title": "某时间期间内的购买次数",
  "purchaseFrequencyWidget.tooltip": "根据您的 Smart Insights 新近设置，会员在选定时间范围内进行的平均购买金额。",
  "purchaseFrequencyWidget.totalsMetaData.loyalty.title": "忠诚度会员",
  "purchaseFrequencyWidget.totalsMetaData.nonLoyalty.title": "非忠诚度会员",
  "purchaseFrequencyWidget.totalsMetaData.uplift.title": "忠诚度提升",
  "vouchersAnalyticsWidget.title": "优惠券分析",
  "vouchersAnalyticsWidget.rewardMetaData.displayName": "优惠券作为奖励",
  "vouchersAnalyticsWidget.rewardMetaData.totalsTooltip": "在选定时间期间内，作为已完成操作的奖励和显示的优惠券代码固定福利而累计的优惠券总数。",
  "vouchersAnalyticsWidget.pointsMetaData.displayName": "积分优惠券",
  "vouchersAnalyticsWidget.pointsMetaData.totalsTooltip": "在选定时间期间内，显示的优惠券代码积分累计的优惠券总数。",
  "vouchersAnalyticsWidget.freeMetaData.displayName": "免费优惠券",
  "vouchersAnalyticsWidget.freeMetaData.totalsTooltip": "所选时间期间内显示的免费优惠券代码累计的优惠券总数。",
  "vouchersAnalyticsWidget.cashbackMetaData.displayName": "现金返还优惠券",
  "vouchersAnalyticsWidget.cashbackMetaData.totalsTooltip": "所选时间期间内显示的现金返还优惠券代码累计的优惠券总数。",
  "widgetHelpLink.tooltip": "查看此数据是如何计算的",
  "viewRange.options.day": "日",
  "viewRange.options.week": "周",
  "viewRange.options.month": "月"
}
